<svg
  xmlns="http://www.w3.org/2000/svg"
  version="1.1"
  viewBox="0 0 2200 2200">
  <defs></defs>
  <g>
    <g id="layer1">
      <rect
        class="rect"
        width="2200"
        height="2200" />
      <circle
        class="outer-circle"
        cx="1100"
        cy="1100"
        r="202.44" />
      <circle
        class="inner-circle"
        cx="1100"
        cy="1100"
        r="540" />
    </g>
  </g>
</svg>
